export default {"src":"/_next/static/media/lighting.be749762.svg","height":75,"width":76};